import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, CandlestickChart, Wallet as WalletIcon, PiggyBank, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import "../mobiletabs.css";

const TABS = [
  { key: "home", label: "Home", icon: Home, path: "/dashboard" },
  { key: "trade", label: "Trade", icon: CandlestickChart, path: "/trade" },
  { key: "wallet", label: "Wallet", icon: WalletIcon, path: "/wallet" },
  { key: "earn", label: "Earn", icon: PiggyBank, path: "/earn" },
  { key: "account", label: "Account", icon: User, path: "/settings" },
];

// Routes where the app chrome (and thus the bottom bar) belongs.
const APP_PREFIXES = ["/dashboard", "/trade", "/wallet", "/assets", "/orders",
  "/referral", "/earn", "/convert", "/rewards", "/security", "/settings", "/support", "/kyc"];

const MobileTabBar = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const show = !!user && APP_PREFIXES.some((p) => location.pathname === p || location.pathname.startsWith(p + "/"));
  const dark = typeof window !== "undefined" && localStorage.getItem("imperio_theme") !== "light";

  useEffect(() => {
    document.body.classList.toggle("has-mtabbar", show);
    return () => document.body.classList.remove("has-mtabbar");
  }, [show]);

  if (!show) return null;

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <nav className={`mtabbar${dark ? " dark" : ""}`} data-testid="mobile-tabbar">
      {TABS.map(({ key, label, icon: Icon, path }) => (
        <button
          key={key}
          className={`mtabbar-item${isActive(path) ? " active" : ""}`}
          onClick={() => navigate(path)}
          data-testid={`mtab-nav-${key}`}
        >
          <Icon size={21} strokeWidth={2} />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
};

export default MobileTabBar;
